<div class="header-container left">
    <div class="logo-containter">
        <a (click)="toggleSidebar()" href="#" class="navigation"><i class="nb-menu"></i></a>
        <div class="logo pointer" (click)="goToHome()">
            <i class="logo-icon nb-location ng-star-inserted"></i>
            DRZ <span *ngIf="!env.production" class="error-message mr-2">(TESTA VIDE)</span><small class="version-number">{{ appVersion }}</small>
        </div>
    </div>
    <button class="btn btn-link ms-2" (click)="openHelp()">Lietotāja palīdzība</button>
</div>

<div class="header-container">
    <nb-actions size="medium" class="normal">
        <nb-action *ngIf="canImpersonateAuthorities" style="width: 30rem;">
            <amdb-authorize-on-behalf-of-header class="w-full"></amdb-authorize-on-behalf-of-header>
        </nb-action>
        <nb-action>
            <nb-user [nbContextMenu]="userMenu" [name]="user?.unique_name"></nb-user>
        </nb-action>
    </nb-actions>
</div>
